import React, { useRef } from "react";
import * as HoverCard from "@radix-ui/react-hover-card";
import { useTranslation } from "react-i18next";

const DashboardOnboarding = ({
  children,
  wrapperClassName,
  videoName,
}: {
  children: React.ReactNode;
  videoName: string;
  wrapperClassName?: string;
}) => {
  const loadingRef = useRef<HTMLDivElement>(null);
  const { i18n } = useTranslation();

  return (
    <HoverCard.Root openDelay={500}>
      <HoverCard.Trigger asChild>
        <div className={wrapperClassName}>{children}</div>
      </HoverCard.Trigger>
      <HoverCard.Portal>
        <HoverCard.Content
          className="w-[350px] rounded-xl bg-[#494949] shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] data-[side=bottom]:animate-slideUpAndFade data-[side=left]:animate-slideRightAndFade data-[side=right]:animate-slideLeftAndFade data-[side=top]:animate-slideDownAndFade data-[state=open]:transition-all"
          sideOffset={5}
        >
          <div className="relative">
            <video
              src={`/tutorials_${i18n.language}/${videoName}.mp4`}
              autoPlay
              loop
              muted
              className="w-full h-full rounded-xl"
              onLoadStart={(e) => {
                const video = e.currentTarget;
                video.style.opacity = "0";
              }}
              onCanPlay={(e) => {
                const video = e.currentTarget;
                video.style.opacity = "1";
                video.style.transition = "opacity 0.3s";
                loadingRef.current?.classList.add("hidden");
              }}
            />

            <div
              ref={loadingRef}
              className="absolute inset-0 flex items-center justify-center transition-opacity"
              style={{ opacity: 1 }}
            >
              <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
            </div>
          </div>

          <HoverCard.Arrow className="fill-white" />
        </HoverCard.Content>
      </HoverCard.Portal>
    </HoverCard.Root>
  );
};

export default DashboardOnboarding;
